const MonthView = ({ currentDate, slots, onSlotClick, mode }) => {
  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    return { daysInMonth, startingDayOfWeek, year, month };
  };

  const formatDate = (year, month, day) => {
    const m = String(month + 1).padStart(2, "0");
    const d = String(day).padStart(2, "0");
    return `${year}-${m}-${d}`;
  };

  const getSlotsForDate = (dateStr) => {
    return slots.filter((slot) => slot.date === dateStr);
  };

  const { daysInMonth, startingDayOfWeek, year, month } = getDaysInMonth(currentDate);
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const calendarDays = [];
  for (let i = 0; i < startingDayOfWeek; i++) {
    calendarDays.push(null);
  }
  for (let day = 1; day <= daysInMonth; day++) {
    calendarDays.push(day);
  }

  return (
    <>
      {/* Day Names Header */}
      <div className="grid grid-cols-7 gap-px bg-slate-200 border border-slate-200 rounded-t-lg overflow-hidden">
        {dayNames.map((day) => (
          <div
            key={day}
            className="bg-slate-100 text-center py-3 text-sm font-semibold text-slate-700"
            style={{ fontFamily: 'Public Sans' }}
          >
            {day}
          </div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div className="calendar-grid rounded-b-lg overflow-hidden">
        {calendarDays.map((day, index) => {
          if (day === null) {
            return (
              <div
                key={`empty-${index}`}
                className="calendar-cell bg-slate-50"
              />
            );
          }

          const dateStr = formatDate(year, month, day);
          const daySlots = getSlotsForDate(dateStr);
          const today = new Date();
          const isToday =
            today.getDate() === day &&
            today.getMonth() === month &&
            today.getFullYear() === year;

          return (
            <div
              key={`day-${day}`}
              data-testid={`calendar-day-${dateStr}`}
              className={`calendar-cell ${
                isToday ? "ring-2 ring-blue-500 ring-inset" : ""
              }`}
            >
              <div className="flex justify-between items-start mb-2">
                <span className={`text-sm font-medium ${
                  isToday ? "text-blue-600" : "text-slate-900"
                }`}>
                  {day}
                </span>
                {daySlots.length > 0 && (
                  <span className="text-xs text-slate-500">
                    {daySlots.length} slot{daySlots.length > 1 ? "s" : ""}
                  </span>
                )}
              </div>

              <div className="space-y-1">
                {daySlots.slice(0, 3).map((slot) => (
                  <div
                    key={slot.slot_id}
                    data-testid={`calendar-slot-${slot.slot_id}`}
                    onClick={() => onSlotClick && (slot.status === "available" || slot.status === "pending") && onSlotClick(slot)}
                    className={`text-xs p-2 rounded border transition-all ${
                      slot.status === "available"
                        ? "bg-emerald-50 border-emerald-200 text-emerald-800 cursor-pointer hover:bg-emerald-100"
                        : slot.status === "booked"
                        ? "bg-rose-50 border-rose-200 text-rose-800"
                        : "bg-amber-50 border-amber-200 text-amber-800 cursor-pointer hover:bg-amber-100"
                    } ${mode === "user" && (slot.status === "available" || slot.status === "pending") ? "hover:border-emerald-400" : ""}`}
                  >
                    <div className="font-medium">
                      {slot.start_time} - {slot.end_time}
                    </div>
                    <div className="text-xs mt-0.5 capitalize">
                      {slot.status === "pending" ? "request pending" : slot.status}
                    </div>
                  </div>
                ))}
                {daySlots.length > 3 && (
                  <div className="text-xs text-slate-500 text-center py-1">
                    +{daySlots.length - 3} more
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default MonthView;